import React, { PropsWithChildren, useState, useEffect } from 'react';

import { Input } from '@eika/input';

type Props = {
    name: string;
    onChange(name: string): void;
};

export const HeaderInput = ({ onChange, name }: PropsWithChildren<Props>) => {
    const [value, setValue] = useState(name);
    useEffect(() => {
        onChange(value);
    }, [onChange, value]);

    return <Input autoFocus className="header-input" value={value} onChange={(v) => setValue(v.target.value)} />;
};
